import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { PermissionCode } from '@beable/roster-backend-client-v1';
import { SelectablePermission } from './PermissionsPanel';

interface PermissionSelectorProps {
    onSelect: (permission: PermissionCode) => void;
    className?: string;
    variant?: 'filled' | 'outlined';
    permissions: SelectablePermission[];
}

export default function PermissionSelector({ variant, className, onSelect, permissions }: PermissionSelectorProps) {
    const [selectedPermission, setSelectedPermission] = useState<PermissionCode | undefined>(undefined);

    const handlePermissionChange = async (event: any) => {
        const permissionCode: PermissionCode = event.target.value;
        setSelectedPermission(permissionCode);
        onSelect(permissionCode);
    };

    return <>
        <FormControl className={className} variant={ variant || 'standard' }>
            <InputLabel id="select-label">Select Permission</InputLabel>
            <Select
                variant={ variant || 'standard' }
                id="select-permission"
                data-cy="permission-select"
                value={selectedPermission ?? ''}
                onChange={handlePermissionChange}>
                {permissions.map((p: SelectablePermission) => (
                    <MenuItem
                      key={p.code}
                      value={p.code}
                      role='option'
                    >
                      {p.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </>;
}
